<template>
    <div>
        <div
            v-for="questionsChunk in questionsChunks"
            class="card">
            <div class="card-body">
                <div
                    v-for="question in questionsChunk"
                    :key="question.uuid">
                    <KeepAlive>
                        <QuestionDecorator
                            :question="question"
                            :registrar-mode="registrarMode"
                            :answers-by-persons="answersByPersons"
                            @event="handleEvent" />
                    </KeepAlive>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import isEqual from 'lodash/isEqual'
import QuestionDecorator from "@/components/pages/registration/questions/QuestionDecorator";
import questionTypes from "@/util/consts/questionTypes";

export default {
    name: "QuestionMain",
    components: {QuestionDecorator},
    props: {
        questions: {
            type: Array,
            required: true
        },
        modelValue: {
            required: true
        },
        registrarMode: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            answersByPersons: null
        }
    },
    computed: {
        questionsChunks() {
            const chunks = [[]]

            for (const question of this.questions) {
                if (question.questionType !== questionTypes.TYPE_PLACEHOLDER) {
                    chunks[chunks.length - 1].push(question)
                } else {
                    chunks.push([])
                }
            }

            this.removeEmptyChunks(chunks)
            return chunks
        }
    },
    methods: {
        removeEmptyChunks(chunks) {
            for (let i = chunks.length - 1; i >= 0; i--) {
                if (!chunks[i].length) chunks.splice(i, 1)
            }
        },
        handleEvent(eventData) {
            if (!this.answersByPersons[eventData.personKey]) {
                this.answersByPersons[eventData.personKey] = {}
            }
            this.answersByPersons[eventData.personKey][eventData.questionUuid] = eventData.answer
        }
    },
    watch: {
        modelValue: {
            handler() {
                if (!isEqual(this.modelValue, this.answersByPersons)) {
                    this.answersByPersons = this.$cloneDeep(this.modelValue)
                    if (!this.answersByPersons) {
                        this.answersByPersons = {}
                    }
                }
            },
            immediate: true,
            deep: true
        },
        answersByPersons: {
            handler() {
                if (!isEqual(this.modelValue, this.answersByPersons)) {
                    this.$emit("update:modelValue", this.$cloneDeep(this.answersByPersons))
                }
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.remove-margin-bottom-of-child-card {
    margin-bottom: -$grid-gutter-width;
}
</style>
